<template>
    <img :src="defaults[type].src" :srcset="defaults[type].srcset" :alt="alt" :title="alt" loading="lazy" class="max-h-128 object-scale-down" :sizes="size" width="700px" />
</template>

<script>
    export default {
        name: 'DefaultPhoto',
        components: {},
        mixins: [],
        props: {
            type: {
                required: true,
                type: String,
                validator: (property) => ['event', 'fundraiser', 'lesson', 'painting', 'product', 'promotion', 'user', 'vendor', 'workshop'].includes(property),
            },
            alt: {
                required: true,
                type: String,
            },
            size: {
                type: String,
                default: '150px',
            },
        },
        data() {
            return {
                defaults: {
                    ...this.$t('defaultPhotos'),
                },
            };
        },
    };
</script>
